import InitialInfo from "./content/initial-info.jsx";
import Compositions from "./content/compositions.jsx";
import Dispatch from "./content/dispatch.jsx";
import Schedule from "./content/Schedule.jsx";
import InspectionLocation from "./content/inspection-location.jsx";

const hasItems = (items) => Array.isArray(items) && items.length > 0;

const hasObject = (item) => {
    return !!item &&
        typeof item === "object" &&
        !Array.isArray(item) &&
        Object.keys(item).length > 0;
};

export default function ReportContent({ data, id }) {

    const sections = {
        garrison: hasObject(data?.garrison),
        compositions: hasItems(data?.garrison?.compositions),
        dispatch: hasItems(data?.garrison?.dispatch),
        schedules: hasItems(data?.garrison?.schedules),
        inspection: hasItems(data?.garrison?.fixedInspectionLocation),
    }

    return (
        <div className="space-y-4">
            {sections.garrison && (
                <InitialInfo title="DADOS INICIAIS" data={data} />
            )}

            {sections.compositions && (
                <Compositions title="COMPOSIÇÃO" data={data} />
            )}

            {sections.dispatch && (
                <Dispatch title="DESPACHOS / ATIVIDADES" data={data} />
            )}

            {sections.schedules && (
                <Schedule title="ATIVIDADES PROGRAMADAS" data={data} />
            )}

            {sections.inspection && (
                <InspectionLocation title="VISTORIA DE POSTO FIXO" data={data} />
            )}
        </div>
    )
}